module.exports = __webpack_public_path__ + "static/media/no-icon.18dcf98c.svg";